import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import type { BlockVariantType } from "../../../../../collaboration/src/shared/types/worksheet";

import { t } from "i18n/i18n";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { TrashDeleteIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectIsEditModeEnabled } from "store/selectors";

interface BlockToolbarProps {
  className?: string;
  blockType: BlockVariantType;
  onDelete: () => void;
  children?: React.ReactNode;
}

export const BlockToolbar: FC<BlockToolbarProps> = ({
  className,
  blockType,
  onDelete,
  children,
}) => {
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);
  return (
    // z-index should be above `Block` (which is 1) to enable proper
    // visibility and interaction with the toolbar.
    <div
      className={twMerge(
        "block-toolbar absolute left-full z-[2] ml-1 flex flex-col items-center gap-1",
        isEditModeEnabled ? "-mr-10" : "",
        className,
      )}
      role="toolbar"
    >
      {children}
      {isEditModeEnabled && onDelete && (
        <SquareIconButton
          aria-label={t("tooltip.delete_block")}
          eventName="Content block - Delete"
          eventProps={{ blockType }}
          kind="caution"
          size="s"
          onClick={onDelete}
        >
          <TrashDeleteIcon />
        </SquareIconButton>
      )}
    </div>
  );
};
